module.exports = __webpack_public_path__ + "images/emoji/chocolate_bar.e040b7851673f5c4062d.png";